import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormItemCommonProps, nameWithPrefix } from '.';
import { labelRule } from '../rules';

export const LabelFormItem = ({ keyPrefix, disabled }: FormItemCommonProps) => {
  const { t } = useTranslation();

  return (
    <Form.Item
      label={t('Label')}
      name={nameWithPrefix({ name: 'label', keyPrefix })}
      rules={[labelRule()]}
    >
      <Input disabled={disabled} />
    </Form.Item>
  );
};
